import Skeleton from "react-loading-skeleton";
import { GroupBase } from "react-select";

import {
  BasicOption,
  SelectInput,
} from "@/modules/form/components/SelectInput/SelectInput";
import { CustomOptionLabel } from "@/modules/groups/components/GroupPicker/components/CustomOptionLabel";
import { LabelAdornment } from "@/modules/theme/components/Label/LabelAdornment";
import { useTheme } from "@/modules/theme/hooks/useTheme";
import { useUserDataContext } from "@/modules/user/hooks/useUserDataContext";

import { createGroupPickerStyles } from "./createGroupPickerStyles";

type GroupPickerProps = {
  onChange: (groupId: string) => void;
  className?: string;
};

export type OptionWithColor = {
  color: string;
} & BasicOption;

export const GroupPicker: React.FC<GroupPickerProps> = ({
  onChange,
  className,
}) => {
  const styles = createGroupPickerStyles<
    OptionWithColor,
    false,
    GroupBase<OptionWithColor>
  >(useTheme());
  const { groups, currentGroup, userDataQueryStatus } = useUserDataContext();

  if (userDataQueryStatus === "loading") {
    return <Skeleton height={32} width={130} />;
  }

  if (!groups || !currentGroup) {
    return null;
  }

  return (
    <div className={className}>
      {groups.length > 1 ? (
        <SelectInput
          name="group"
          showErrorMessage={false}
          styles={styles}
          onChange={(value) => {
            if (!value || Array.isArray(value)) return;
            onChange(value.toString());
          }}
          options={groups.map(({ id, name, colorHex }) => ({
            label: name,
            value: id,
            color: colorHex,
          }))}
          defaultValue={{
            label: currentGroup.name,
            value: currentGroup.id,
            color: currentGroup.colorHex,
          }}
          formatOptionLabel={(props) => <CustomOptionLabel {...props} />}
        />
      ) : (
        <LabelAdornment
          text={currentGroup.name}
          color={currentGroup.colorHex}
          isLarge
        />
      )}
    </div>
  );
};
